module.exports = __webpack_public_path__ + "img/computer.08c38d0a.svg";